import styled from '@emotion/styled';
import { KizenTypography } from '__app/typography';
import { TextEllipsisWithTooltip } from '__components/Kizen/Table';

type StaticLinkProps = {
  label: string;
  link: string;
  linkLabel: string;
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled(TextEllipsisWithTooltip)`
  height: 14px;
  margin-bottom: 12px;
`;

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  height: 36px;
`;

export const StaticLink = (props: StaticLinkProps) => {
  const { label, link, linkLabel } = props;

  return (
    <Container>
      <Label>{label}</Label>
      <InputContainer>
        <KizenTypography type="link" target="_blank" to={link}>
          {linkLabel}
        </KizenTypography>
      </InputContainer>
    </Container>
  );
};
